import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import { KEYS } from '../../constants/keys.js';
import { mergeProps } from '../../utils/react.js';
import { useButtonMenuContext, FOCUS_ELEMENTS } from '../ButtonMenuContainer/ButtonMenuContainer.js';

var ButtonMenuTrigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var context = useButtonMenuContext();
  var children = props.children;
  var handleClick = function handleClick() {
    context.setShowingState(!context.showingState);
    context.setFocusItem(context.showingState ? FOCUS_ELEMENTS.BUTTON : FOCUS_ELEMENTS.MENU);
  };
  var handleKeydown = function handleKeydown(e) {
    switch (e.key) {
      case KEYS.ARROW_DOWN:
      case KEYS.SPACE:
        {
          context.setShowingState(true);
          context.setFocusItem(FOCUS_ELEMENTS.MENU);
          e.preventDefault();
          break;
        }
      case KEYS.ARROW_UP:
        {
          context.setShowingState(true);
          context.setFocusItem(FOCUS_ELEMENTS.LAST_ITEM);
          e.preventDefault();
          break;
        }
    }
  };
  if (! /*#__PURE__*/React.isValidElement(children)) return children;
  if (!React.Children.only(children)) return children;
  var item = children;
  return /*#__PURE__*/React.cloneElement(item, mergeProps({
    ref: ref
  }, _objectSpread(_objectSpread({}, item.props), {}, {
    ref: item.ref
  }), {
    "aria-expanded": context.showingState ? true : void 0,
    "aria-haspopup": true,
    id: context.id,
    role: "button",
    onClick: handleClick,
    onKeyDown: handleKeydown,
    ref: context.buttonRef
  }));
});
ButtonMenuTrigger.displayName = "ButtonMenuTrigger";

export { ButtonMenuTrigger };
